import axios from "axios";

import { API_CALL_URL } from "../constants";

export enum AffiliateTypeEnum {
  GOODS = "goods",
  SERVICE = "service",
}

export type AffiliateApiResponse = {
  id: string;
  affiliateName: string;
  affiliateType: AffiliateTypeEnum;
  affiliateCode: string;
  affiliateSummary: string;
  createdAt: Date;
  updatedAt: Date;
};

export type AffiliateUpsertRequest = {
  id?: string;
  affiliateName: string;
  affiliateType: AffiliateTypeEnum;
  affiliateCode: string | null;
  affiliateSummary: string | null;
};

export const fetchAffiliate = async (): Promise<AffiliateApiResponse[]> => {
  try {
    const response = await axios.get<AffiliateApiResponse[]>(`${API_CALL_URL}/affiliate`);
    return response.data;
  } catch (error) {
    console.error("Axios error:", error);
    return [];
  }
};

export const upsertAffiliate = async ({
  id,
  affiliateName,
  affiliateType,
  affiliateCode,
  affiliateSummary,
}: AffiliateUpsertRequest): Promise<void> => {
  try {
    await axios.post(`${API_CALL_URL}/affiliate`, {
      id: id ?? undefined,
      affiliateName,
      affiliateType,
      affiliateCode,
      affiliateSummary,
    });
  } catch (error) {
    console.error("Axios error:", error);
  }
};

export const deleteAffiliate = async (id: string): Promise<void> => {
  try {
    await axios.delete(`${API_CALL_URL}/affiliate/${id}`);
  } catch (error) {
    console.error("Axios error:", error);
  }
};
